import { request } from "@/interface/helper";

const str = "idoRecommend";

export const idoRecommend = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/ido/recommend/list" }),
    add: (data) => request({ data, method: "post", url: "/ido/recommend/add" }),
    detail: (data) => request({ data, method: "post", url: "/ido/recommend/detail" }),
    edit: (data) => request({ data, method: "post", url: "/ido/recommend/modify" }),
  },
};
